import React, { useState, useRef } from 'react';
import api from '../api/client';

export default function Modes({ token, onLogout }){
  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <div>Logged in</div>
        <button onClick={onLogout}>Logout</button>
      </div>
      <h3>Three Modes</h3>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
        <VoiceMode token={token}/>
        <NfcMode token={token}/>
        <ManualMode token={token}/>
      </div>
    </div>
  );
}

function VoiceMode({token}){
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState('');
  const [response, setResponse] = useState('');
  const recognitionRef = useRef(null);

  async function start(){
    setResponse('');
    if(!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)){
      setResponse('SpeechRecognition not supported in this browser.');
      return;
    }
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SpeechRecognition();
    rec.lang = 'en-IN';
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (e)=> {
      const t = e.results[0][0].transcript;
      setTranscript(t);
    };
    rec.onerror = (e)=> setResponse('Recognition error: '+(e && e.error ? e.error : String(e)));
    rec.onend = ()=> setListening(false);
    recognitionRef.current = rec;
    rec.start();
    setListening(true);
  }

  async function send(){
    setResponse('Parsing & posting...');
    try{
      const intentResp = await api.post('/agents/intent', { transcript });
      const j = intentResp.data || {};
      const parsed = j.parsed || {};
      const event = {
        event_uuid: 'evt-'+Date.now(),
        event_type: parsed.event_type || 'voice_unknown',
        mode: 'voice',
        actor_id: parsed.actor_id || null,
        student_id: parsed.student_id || null,
        local_timestamp: new Date().toISOString(),
        voice_payload: { transcript, parsed }
      };
      const postResp = await api.post('/events', event);
      setResponse('Posted: ' + (postResp.status || '') + ' ' + JSON.stringify(postResp.data || ''));
    }catch(e){
      const msg = (e && e.message) ? e.message : JSON.stringify(e);
      setResponse('Error: '+msg);
    }
  }

  return (
    <div style={{border:'1px solid #ddd',padding:12}}>
      <h4>Voice Mode</h4>
      <div><button onClick={start} disabled={listening}>{listening? 'Listening...':'Start'}</button></div>
      <div style={{marginTop:8}}><label>Transcript</label><textarea value={transcript} onChange={e=>setTranscript(e.target.value)} rows={5}></textarea></div>
      <div style={{marginTop:8}}><button onClick={send}>Parse & Post</button></div>
      <pre>{response}</pre>
    </div>
  );
}

function NfcMode({token}){
  const [msg, setMsg] = useState('');
  async function readNfc(){
    setMsg('');
    if(!('NDEFReader' in window)){
      setMsg('WebNFC not supported (Chrome Android only). Use mobile app or manual mode.');
      return;
    }
    try {
      const ndef = new NDEFReader();
      await ndef.scan();
      ndef.onreading = e=>{
        const records = e.message.records;
        for(const rec of records){
          try {
            const textDecoder = new TextDecoder(rec.encoding || 'utf-8');
            const payload = textDecoder.decode(rec.data);
            setMsg('Tag: '+payload);
          } catch(err){ setMsg('Error reading tag'); }
        }
      };
      setMsg('Waiting for tag...');
    } catch(err){ setMsg('NFC error: '+(err && err.message ? err.message : String(err))); }
  }

  async function postSample(){
    const event = {
      event_uuid:'evt-'+Date.now(),
      event_type:'classroom_checkin',
      mode:'nfc',
      actor_id:'student_001',
      student_id:'STU-001',
      nfc_payload:{nfc_id:'classroom_7A'},
      local_timestamp:new Date().toISOString()
    };
    try{
      const resp = await api.post('/events', event);
      setMsg('Posted: ' + (resp.status || '') + ' ' + JSON.stringify(resp.data || ''));
    }catch(e){
      setMsg('Error posting: ' + ((e && e.message) ? e.message : JSON.stringify(e)));
    }
  }

  return (
    <div style={{border:'1px solid #ddd',padding:12}}>
      <h4>NFC Mode</h4>
      <div><button onClick={readNfc}>Scan Tag (WebNFC)</button></div>
      <div style={{marginTop:8}}><button onClick={postSample}>Post Sample NFC Event</button></div>
      <pre>{msg}</pre>
    </div>
  );
}

function ManualMode({token}){
  const [jsonText,setJsonText] = useState(JSON.stringify({event_uuid:'evt-'+Date.now(), event_type:'bus_boarding', student_id:'STU-1001', actor_id:'guard_1', local_timestamp:new Date().toISOString()},null,2));
  const [out,setOut] = useState('');
  async function send(){
    try{
      const payload = JSON.parse(jsonText);
      const resp = await api.post('/events', payload);
      setOut('Posted: ' + (resp.status || '') + ' ' + JSON.stringify(resp.data || ''));
    }catch(e){
      const msg = (e && e.message) ? e.message : JSON.stringify(e);
      setOut('Error: '+msg);
    }
  }
  return (
    <div style={{border:'1px solid #ddd',padding:12}}>
      <h4>Manual Mode</h4>
      <textarea rows={8} style={{width:'100%'}} value={jsonText} onChange={(e)=>setJsonText(e.target.value)} />
      <div style={{marginTop:8}}>
        <button onClick={send}>Post Event</button>
      </div>
      <pre>{out}</pre>
    </div>
  );
}
